import * as R from 'ramda';
// constants
import * as GC from '../constants';
// helpers
import { isNilOrEmpty } from './helpers';
import { getAmousConfigByNameFromWindow } from './window';
import { toTitleCase, createStringFromArray } from './string';
//////////////////////////////////////////////////

const getFirstDriverInfo = ({ fleetAssignment }) => {
  const firstName = R.pathOr('', [GC.SYSTEM_OBJECT_PRIMARY_DRIVER, GC.FIELD_FIRST_NAME], fleetAssignment);
  const lastName = R.pathOr('', [GC.SYSTEM_OBJECT_PRIMARY_DRIVER, GC.FIELD_LAST_NAME], fleetAssignment);

  return `${firstName} ${lastName}`;
};

const getFirstDriverInfoLoginId = ({ fleetAssignment }) => {
  const loginId = R.pathOr('', [GC.SYSTEM_OBJECT_PRIMARY_DRIVER, GC.FIELD_USER_LOGIN_ID], fleetAssignment);

  if (isNilOrEmpty(loginId)) return '';

  return loginId;
};

const getTeamDriverInfo = ({ fleetAssignment }) => {
  const firstName = R.pathOr('', [GC.SYSTEM_OBJECT_SECONDARY_DRIVER, GC.FIELD_FIRST_NAME], fleetAssignment);
  const lastName = R.pathOr('', [GC.SYSTEM_OBJECT_SECONDARY_DRIVER, GC.FIELD_LAST_NAME], fleetAssignment);

  if (R.and(isNilOrEmpty(firstName), isNilOrEmpty(lastName))) return null;

  return `${firstName} ${lastName}`;
};

const getTeamDriverInfoLoginId = ({ fleetAssignment }) => {
  const loginId = R.pathOr('', [GC.SYSTEM_OBJECT_SECONDARY_DRIVER, GC.FIELD_USER_LOGIN_ID], fleetAssignment);

  if (isNilOrEmpty(loginId)) return '';

  return loginId;
};

const getPrimaryDriverGuid = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return null;

  return R.pathOr('', [GC.FIELD_PRIMARY_DRIVER, GC.FIELD_GUID], fleetAssignment);
};

const getTeamDriverGuid = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return null;

  return R.pathOr('', [GC.FIELD_SECONDARY_DRIVER, GC.FIELD_GUID], fleetAssignment);
};

const getPrimaryDriverPhone = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  return R.pathOr('', [GC.FIELD_PRIMARY_DRIVER, GC.FIELD_PHONE_NUMBER], fleetAssignment);
};

const getPrimaryDriverEmail = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  return R.pathOr('', [GC.FIELD_PRIMARY_DRIVER, GC.FIELD_EMAIL], fleetAssignment);
};

const getTeamDriverPhone = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  return R.pathOr('', [GC.FIELD_SECONDARY_DRIVER, GC.FIELD_PHONE_NUMBER], fleetAssignment);
};

const getTeamDriverEmail = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  return R.pathOr('', [GC.FIELD_SECONDARY_DRIVER, GC.FIELD_EMAIL], fleetAssignment);
};

const getTrailersInfo = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  const trailers = R.map((item) => (
    R.prop(GC.FIELD_TRUCK_UNIT_ID, item)
  ), R.pathOr([], [GC.SYSTEM_LIST_TRAILERS], fleetAssignment));

  return createStringFromArray(trailers, ', ');
};

const getTruckInfo = ({ fleetAssignment }) => {
  if (isNilOrEmpty(fleetAssignment)) return '';

  return R.pathOr('', [GC.FIELD_TRUCK, GC.FIELD_TRUCK_UNIT_ID], fleetAssignment);
};

const getFleetProfileRoutePathNameByFleetType = (type = 'driver') => `fleet${toTitleCase(type)}Profile`;

export {
  getTruckInfo,
  getTrailersInfo,
  getTeamDriverInfo,
  getTeamDriverGuid,
  getTeamDriverEmail,
  getFirstDriverInfo,
  getTeamDriverPhone,
  getPrimaryDriverGuid,
  getPrimaryDriverEmail,
  getPrimaryDriverPhone,
  getTeamDriverInfoLoginId,
  getFirstDriverInfoLoginId,
  getFleetProfileRoutePathNameByFleetType,
};
